<template>
    <!-- <div>
        <h1>Evaluations</h1>
        <p v-if="loading">Loading...</p>
        <div v-else>
            Loaded!
            <ul>
                <li v-for="evaluation in evaluations" :key="evaluation.evaluation_id">
                    {{ evaluation.evaluation_id }} {{ evaluation.status }} ( crated on {{ evaluation.createdOn }} )
                </li>
            </ul>
        </div>        
    </div> -->
    <v-container>
        <v-row>
            <v-col cols="12" class="text-h4">
                {{ $t('psychologistEvaluations.evaluations') }}
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-btn to="newEvaluation">
                    {{ $t('psychologistEvaluations.new_evaluation') }}
                </v-btn>
            </v-col>
        </v-row>

        <!--Alternative way to display the data (https://claude.ai/chat/66a60128-6e8a-4d53-aca4-844647dd0211) -->
        <v-row>
            <v-col cols="12">
                <v-card 
                    v-for="(evaluation, idx) in evaluations" 
                    :key="`${evaluation.evaluation_id}`"
                    class="mb-2"
                >
                    <v-container>           
                        <!-- Desktop layout -->
                        <v-row @click="onRow(evaluation.token)" class="d-none d-sm-flex clickable-area">
                            <!-- Desktop layout -->
                             <v-col cols="2" class="text-center">
                                <div class="text-caption text-grey">{{ $t('psychologistEvaluations.created_on') }}</div>
                                <div class="d-flex flex-column">
                                    <div>{{ formatDate(evaluation.createdOn) }}</div>
                                    <div class="text-disabled">{{ formatTime(evaluation.createdOn) }}</div>
                                </div>
                            </v-col>
                            <v-col cols="3" class="text-center">
                                <div class="text-caption text-grey">{{ $t('psychologistEvaluations.client') }}</div>
                                <div>{{ evaluation.client.first_name }}</div>
                            </v-col>
                            <v-col cols="3" class="text-center">
                                <div class="text-caption text-grey">{{ $t('psychologistEvaluations.scales') }}</div>
                                <div>
                                    <v-chip v-for="scale in evaluation.scales"
                                        :key="scale.scale_id"
                                        size="small"
                                        variant="outlined">
                                        {{ scale.name }}
                                    </v-chip>
                                </div>
                            </v-col>
                            <v-col cols="2" class="text-center">
                                <div class="text-caption text-grey">{{ $t('psychologistEvaluations.status') }}</div>
                                <v-chip
                                    :style="{color: 'black', backgroundColor: statusColor(evaluation.status) }"
                                    :text="evaluation.status"
                                />
                            </v-col>
                            <v-col cols="2" class="text-center d-flex align-center justify-center">
                                <v-btn
                                    color="error"
                                    size="small"
                                    variant="outlined"
                                    @click.stop="confirmDelete(evaluation)"
                                >
                                    {{ $t('psychologistEvaluations.delete_button') }}
                                </v-btn>
                            </v-col>
                        </v-row>
                        
                        <!-- Mobile layout -->
                        <div @click="onRow(evaluation.token)" class="d-sm-none clickable-area">
                            <v-row dense>
                                <v-col cols="8">
                                    <div class="text-caption text-grey">{{ $t('psychologistEvaluations.created_on') }}</div>
                                    <div class="d-flex flex-column">
                                        <div>{{ formatDate(evaluation.createdOn) }}</div>
                                        <div class="text-disabled">{{ formatTime(evaluation.createdOn) }}</div>
                                    </div>
                                </v-col>
                                <v-col cols="4">
                                    <div class="text-caption text-grey">{{ $t('psychologistEvaluations.client') }}</div>
                                    <div>{{ evaluation.client.first_name }}</div>
                                </v-col>
                            </v-row>
                            <v-row dense class="mt-2">
                                <v-col class="d-flex align-center" cols="8">
                                    <div class="text-caption text-grey">{{ $t('psychologistEvaluations.scales') }}</div>
                                    <div class="ml-1">
                                        <v-chip v-for="scale in evaluation.scales"
                                            :key="scale.scale_id"
                                            size="small"
                                            variant="outlined">
                                            {{ scale.name }}
                                        </v-chip>
                                    </div>
                                </v-col>
                                <v-col cols="4" class="text-right">
                                    <div class="text-caption text-grey text-left">{{ $t('psychologistEvaluations.status') }}</div>
                                    <v-chip
                                        :style="{color: 'black', backgroundColor: statusColor(evaluation.status) }"
                                        :text="evaluation.status"
                                        size="small"
                                    />
                                </v-col>
                            </v-row>
                            <v-row dense class="mt-2">
                                <v-col cols="12" class="text-right">
                                    <v-btn
                                        color="error"
                                        size="small"
                                        variant="outlined"
                                        @click.stop="confirmDelete(evaluation)"
                                    >
                                        Delete
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </div>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </v-container>

    <!-- Delete confirmation dialog -->
    <v-dialog v-model="deleteDialog" max-width="400">
        <v-card>
            <v-card-title>{{ $t('psychologistEvaluations.delete_title') }}</v-card-title>
            <v-card-text>
                {{ $t('psychologistEvaluations.delete_confirm') }}
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn @click="deleteDialog = false">{{ $t('psychologistEvaluations.delete_cancel') }}</v-btn>
                <v-btn color="error" @click="deleteEvaluation">{{ $t('psychologistEvaluations.delete_button') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>

<script>
import apiService from '@/services/ApiService'
import {formatDate, formatTime} from '@/utils/time.js'

export default {
    // components: {
    //     QuestionnaireComponent,
    // },

    data() {
        return {
            evaluations: [],
            loading: true,
            deleteDialog: false,
            evaluationToDelete: null,
        };
    },

    name: 'PsychologistEvaluations',

    async created() {
        // console.log('NODE_ENV:', process.env.NODE_ENV);
        // console.log('All process.env:', process.env);
        // console.log('VUE_APP_API_ENDPOINT:', process.env.VUE_APP_API_ENDPOINT);

        // const apiUrl = 'http://localhost:7070/api'; // Adjust the API endpoint as needed
        // You can perform any asynchronous operations here if needed
        console.log('PsychologistEvaluations mounted');
        
        await this.loadEvaluations();
    },

    // async mounted() {
    //     console.log('NODE_ENV:', process.env.NODE_ENV);
    //     console.log('All process.env:', process.env);
    //     console.log('VUE_APP_API_ENDPOINT:', process.env.VUE_APP_API_ENDPOINT);

    //     // const apiUrl = 'http://localhost:7070/api'; // Adjust the API endpoint as needed
    //     // You can perform any asynchronous operations here if needed
    //     console.log('UsersView mounted');
    //     try {

    //         let users = await apiService.getClientsForPsychologist()
    //         console.log('Response:', users);

    //         this.users = users;
    //     } catch (error) {
    //         console.error('Error fetching data:', error);
    //     } finally {
    //         this.loading = false;
    //     }
    // }

    methods:{
        formatDate,
        formatTime,

        async loadEvaluations(){
            try {
                this.loading = true
                let evaluations = await apiService.getEvaluations()
                console.log('Response:', evaluations);

                this.evaluations = evaluations.data;
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                this.loading = false;
            }
        },
        
        statusColor: (status) => {
            if(status === 'fresh'){
                return "yellow"
            }
            else if(status === 'started'){
                return "orange"
            }
            else if(status === 'completed'){
                return "green"
            }
            else{
                return "grey"
            }
        },

        confirmDelete(evaluation) {
            // Set current evaluation 
            this.evaluationToDelete = evaluation;

            // Trigger confirmation dialog
            this.deleteDialog = true;
        },

        async deleteEvaluation() {
            try {
                await apiService.deleteEvaluation(this.evaluationToDelete.evaluation_id);
                this.evaluations = this.evaluations.filter(
                    e => e.evaluation_id !== this.evaluationToDelete.evaluation_id
                );
            } catch (error) {
                console.error('Error deleting evaluation:', error);
            } finally {
                // Hide confirmation dialog
                this.deleteDialog = false;

                // Clear current evaluation
                this.evaluationToDelete = null;
            }
        },

        // onRow(evaluationId) {
        onRow(evaluationToken) {
            // console.log(`PsychologistEvaluations > onRow > evaluationId = ${evaluationId}`);
            console.log(`PsychologistEvaluations > onRow > evaluationToken = ${evaluationToken}`);
            // Navigate with parameters
            this.$router.push({ 
                path: `/psychologist/viewEvaluation/${evaluationToken}`, 
            })
        }
    }
}
</script>

<style scoped>

</style>